import { render, staticRenderFns } from "./AlertWidgetSettingsPopoutApp.vue?vue&type=template&id=0794e48c"
import script from "./AlertWidgetSettingsPopoutApp.vue?vue&type=script&lang=js"
export * from "./AlertWidgetSettingsPopoutApp.vue?vue&type=script&lang=js"
import style0 from "./AlertWidgetSettingsPopoutApp.vue?vue&type=style&index=0&id=0794e48c&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports